export default __webpack_public_path__ + "static/media/hamburger.2a67ab03.svg";